module.exports = __webpack_public_path__ + "static/media/victory.344b5d23.mp3";